import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { MonitoringService } from './monitoring.service';

@Injectable()
export class MonitoringErrorHandler extends ErrorHandler {
  private readonly injector = inject(Injector);

  override handleError(error: unknown): void {
    const monitoring = this.injector.get(MonitoringService);
    const err = error instanceof Error ? error : new Error(String(error));

    monitoring.logException(err);
    super.handleError(error);
  }
}
